import { type DeviceAdapter } from './DeviceAdapter';
import { createDevice } from '../../core/util/device';

export const realDevice: DeviceAdapter = createDevice({
  get userAgent() {
    return navigator.userAgent;
  },
  get platform() {
    return navigator.platform;
  },
  get maxTouchPoints() {
    return navigator.maxTouchPoints;
  },
  get viewport() {
    return { width: window.innerWidth, height: window.innerHeight };
  },
});
